import { createFileRoute } from '@tanstack/react-router'
import { QuickTasksPage } from '@/features/quick-tasks/QuickTasksPage'

export const Route = createFileRoute('/_authenticated/quick-tasks')({
  component: QuickTasksPage,
})
